import { Card, Col, DatePicker, Divider, Input, Row } from 'antd'

import { Text } from 'src/components'
import { dayMonthYearFormatWithDot, disabledFutureDate } from 'src/libs'
import { useLocales } from 'src/locales'

import { HivDoctorSelect } from '../fields/HivDoctorSelect'
import { HivFormItem } from '../HivFormItem'
import { HivInstitutionSelect } from '../HivInstitutionSelect'

/** Header (fields 1–2) and A. Medical institutions (fields 3–4.1). */
export const HeaderInstitutionsCard = () => {
  const { t } = useLocales()

  return (
    <Card title={t('hiv_anamnesis.header.title')}>
      <Row gutter={[24, 24]}>
        <Col xs={24} lg={8}>
          <HivFormItem
            name={['form', 'header', 'epidemiologyNumber']}
            number="1"
            label={t('hiv_anamnesis.header.epidemiology_number')}
            extra={t('hiv_anamnesis.header.epidemiology_number_hint')}
          >
            <Input disabled placeholder="-" />
          </HivFormItem>
        </Col>

        <Col xs={24} lg={8}>
          <HivFormItem
            name={['form', 'header', 'anonymousIdentifier']}
            number="2"
            label={t('hiv_anamnesis.header.anonymous_identifier')}
          >
            <Input
              maxLength={50}
              placeholder={t('hiv_anamnesis.header.anonymous_identifier')}
            />
          </HivFormItem>
        </Col>
      </Row>

      <Divider />

      <Text size="xl">{t('hiv_anamnesis.institutions.title')}</Text>

      <Row gutter={[24, 24]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <HivFormItem
            name={['form', 'institutions', 'reportingInstitutionId']}
            number="3"
            label={t('hiv_anamnesis.institutions.reporting_institution')}
          >
            <HivInstitutionSelect />
          </HivFormItem>
        </Col>

        <Col xs={24} lg={12}>
          <HivFormItem
            name={['form', 'institutions', 'arvInstitutionId']}
            number="3.1"
            label={t('hiv_anamnesis.institutions.arv_institution')}
          >
            <HivInstitutionSelect />
          </HivFormItem>
        </Col>

        <Col xs={24} lg={12}>
          <HivFormItem
            name={['form', 'institutions', 'doctorUserId']}
            number="4"
            label={t('hiv_anamnesis.institutions.doctor_full_name')}
          >
            <HivDoctorSelect />
          </HivFormItem>
        </Col>

        <Col xs={24} lg={12}>
          <HivFormItem
            name={['form', 'institutions', 'collectedAt']}
            number="4.1"
            label={t('hiv_anamnesis.institutions.collected_at')}
          >
            <DatePicker
              className="full-width"
              format={dayMonthYearFormatWithDot}
              disabledDate={disabledFutureDate}
              placeholder={t('hiv_anamnesis.institutions.collected_at')}
            />
          </HivFormItem>
        </Col>
      </Row>
    </Card>
  )
}
